/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArElementFromJSON, StreemApiArElementToJSON, } from './';
export function StreemApiCreateStreemshotRevisionRequestFromJSON(json) {
    return StreemApiCreateStreemshotRevisionRequestFromJSONTyped(json, false);
}
export function StreemApiCreateStreemshotRevisionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'arElements': !exists(json, 'ar_elements') ? undefined : (json['ar_elements'].map(StreemApiArElementFromJSON)),
        'edited': !exists(json, 'edited') ? undefined : json['edited'],
    };
}
export function StreemApiCreateStreemshotRevisionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'storage_url': value.storageUrl,
        'ar_elements': value.arElements === undefined ? undefined : (value.arElements.map(StreemApiArElementToJSON)),
        'edited': value.edited,
    };
}
//# sourceMappingURL=StreemApiCreateStreemshotRevisionRequest.js.map